export default __webpack_public_path__ + "historyFilterIcon.34d3710e.png";